module.exports = __webpack_public_path__ + "static/img/1.2561da7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/3/zh/1.png
// module id = kW2b
// module chunks = 0